import { isNil } from 'lodash';

export const isInvalid = (value?: string | number): boolean => isNil(value) || value === '';
